import * as tslib_1 from "tslib";
import { OnInit, } from '@angular/core';
import { FormControl, Validators, } from '@angular/forms';
import { MachineType, RobotHostingType, RobotType, } from '@models';
import { RobotCredentialsControl, RobotFormControl, RobotModalBaseComponent, } from '@pages/robots/modal/robot-base.modal';
import { MAX_NUMBER_OF_RESULTS } from '@pages/shared/constants';
import { MachineService } from '@services';
import { addToObjectIf } from '@utils/object.utils';
import UiValidators, { UI_MACHINE_NAME_MAX_LENGTH } from '@validators';
import { of } from 'rxjs';
import { switchMap } from 'rxjs/operators';
var StandardRobotModalComponent = /** @class */ (function (_super) {
    tslib_1.__extends(StandardRobotModalComponent, _super);
    function StandardRobotModalComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.isMachinesCreateGranted$ = _this._appState.user.permissions.isGranted('Machines.Create');
        _this.isMachinesViewGranted$ = _this._appState.user.permissions.isGranted('Machines.View');
        _this._machineService = _this._injector.get(MachineService);
        _this.translateMachineLabel = function (value) {
            return _this._translateService.instant('robot_modal_form_machine_custom_value', { value: value });
        };
        _this.machineSearchFactory = function (query, step, skip) {
            if (step === void 0) { step = MAX_NUMBER_OF_RESULTS; }
            if (skip === void 0) { skip = 0; }
            return _this.isMachinesViewGranted$
                .pipe(switchMap(function (isGranted) { return isGranted && _this.context.isNewEntry ?
                _this._machineService.machineNameSuggest(query, step, skip, MachineType.Standard) :
                of({
                    data: [],
                    total: 0,
                }); }));
        };
        _this._getFormValueToCreateAnother = function (robot) {
            var _a, _b, _c, _d;
            return (tslib_1.__assign((_a = {}, _a[RobotFormControl.hostingType] = robot.hostingType, _a[RobotFormControl.type] = [_this._robotTypeToDropdownEntry(robot.type)], _a[RobotFormControl.isExternalLicense] = !!robot.isExternalLicense, _a), addToObjectIf(robot.type !== RobotType.Attended, (_b = {},
                _b[RobotFormControl.robotCredentials] = (_c = {},
                    _c[RobotCredentialsControl.credentialStore] = [_this._credentialStoreToDropdownEntry(_this.selectedCredentialStore)],
                    _c),
                _b)), (_d = {}, _d[RobotFormControl.machine] = [{
                    id: robot.machineId,
                    text: robot.machineName,
                }], _d)));
        };
        return _this;
    }
    Object.defineProperty(StandardRobotModalComponent.prototype, "hostingType", {
        get: function () {
            return RobotHostingType.Standard;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(StandardRobotModalComponent.prototype, "formTitle", {
        get: function () {
            return this._translateService.instant('robot_modal_form_standard_title');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(StandardRobotModalComponent.prototype, "formDescription", {
        get: function () {
            return this._translateService.instant('robot_modal_form_standard_info_text');
        },
        enumerable: true,
        configurable: true
    });
    StandardRobotModalComponent.prototype.ngOnInit = function () {
        _super.prototype.ngOnInit.call(this);
        this.robotForm.addControl(RobotFormControl.machine, new FormControl(this.context.data.machineName ? [{
                id: this.context.data.machineId,
                text: this.context.data.machineName,
            }] : [], Validators.compose([
            UiValidators.required(),
            UiValidators.maxLength(UI_MACHINE_NAME_MAX_LENGTH, {
                property: 'text',
            }),
        ])));
    };
    StandardRobotModalComponent.prototype._formValueToPayload = function (formValue) {
        var payload = _super.prototype._formValueToPayload.call(this, formValue);
        var selectedMachineEntry = this.robotForm.get(RobotFormControl.machine).value[0];
        return tslib_1.__assign({}, payload, { machineId: selectedMachineEntry.id !== selectedMachineEntry.text ? selectedMachineEntry.id : null, machineName: selectedMachineEntry.text });
    };
    return StandardRobotModalComponent;
}(RobotModalBaseComponent));
export { StandardRobotModalComponent };
